import http from "@/core/services/http.service";

const ChargeService = {
  createCharge(data, expand = '') {
    return http.post(`/api/v1/finances/charges/?expand=${expand}`, data)
  },
  updateCharge(uuid, data, expand = '') {
    return http.put(`/api/v1/finances/charges/${uuid}/?expand=${expand}`, data)
  }

}

export default ChargeService;